import axios from 'axios';
import * as Sentry from "@sentry/vue";

export default {
    fetchFarms() {
        let options = {};
        options = Object.assign({}, options = {
            method: 'get',
            url: `/umbraco/api/VisitorSignin/getfarms`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchFarmManager(farmId) {
        const options = {
            method: 'get',
            url: `/umbraco/api/VisitorSignin/getfarmmanager?farmId=${farmId}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchContractors() {

        let options = Object.assign({}, {
            method: 'get',
            url: `/umbraco/api/VisitorSignin/GetContractors`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchContractorProjects(farmId) {

        let options = Object.assign({}, {
            method: 'get',
            url: `/umbraco/api/VisitorSignin/GetContractorProjects?farmId=${farmId}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchHazards(farmId) {
        const options = {
            method: 'get',
            url: `/umbraco/api/VisitorSignin/GetHazards?farmId=${farmId}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchHazardMap(farmId) {
        const options = {
            method: 'get',
            url: `/umbraco/api/VisitorSignin/GetHazardMap?farmId=${farmId}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchSignins(farmId) {
        const options = {
            method: 'get',
            url: `/umbraco/api/VisitorSignin/GetSignins?farmId=${farmId}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    signIn(signInModel) {

        let options = {
            method: 'post',
            url: `/umbraco/api/VisitorSignin/Signin`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: signInModel
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    signOut(signOutModel) {

        const options = {
            method: 'post',
            url: `/umbraco/api/VisitorSignin/Signout`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: signOutModel
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    }
}